import React, { Component } from 'react';
import $ from "jquery";
import PdfViewer from './PdfViewer';
import PartnerCreateModal from './PartnerCreateModal';

class ReportReturnCNoteModal extends Component {

    componentDidMount() {
        this.closeAction();
    }

    closeAction = () => {
        const { cleanData } = this.props;
        $('#ReportReturnCNoteModal').on('hidden.bs.modal', function () {
            cleanData();
        });
    };

    render() {
        const {
            ReportsModel,
            ActualDate,
            ChangeInitialDate,
            ChangeFinalDate,
            ChangeReturn,
            ChangeCNote,
            GenerateReport,
            ListReports,
            ShowPDFViewerModal,
            ShowPDFViewer,
            partners,
            pageTotal,
            SelectPartner,
            cleanDataPartners,
            RefreshPartner,
            MailTools,
            sucursales,
            ChangeSucursal,
            printhide,
            ShowFormatToPrint,
        } = this.props;

        return (
            <div className="modal fade" id="ReportReturnCNoteModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="reportSalesModalLabel" aria-hidden="true" >
                <div className="modal-dialog modal-lg modal-dialog-centered" >
                    <div className="modal-content">
                        <div className="modal-header" style={{ background: "#343a40" }}>
                            <h5 style={{ color: "white" }}>Reporte de Devoluciones y Notas de Crédito</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{ color: "white" }} >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="mt-2">
                                <div className='row'>
                                    <div className='col-12 col-md-6'>
                                        <div className="input-group mt-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text"><strong>Desde: </strong></span>
                                            </div>
                                            <input
                                                type="date" className="form-control"
                                                max={ActualDate}
                                                value={ReportsModel.InitialDate}
                                                onChange={(event) => ChangeInitialDate(event)}
                                            />
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-6'>
                                        <div className="input-group mt-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text"><strong>Hasta: </strong></span>
                                            </div>
                                            <input
                                                type="date" className="form-control"
                                                max={ActualDate}
                                                value={ReportsModel.FinalDate}
                                                onChange={(event) => ChangeFinalDate(event)}
                                            />
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-6'>
                                        <div className="input-group mt-3">
                                            <div className='input-group-prepend'>
                                                <span className='input-group-text'><strong>Sucursal:</strong></span>
                                            </div>
                                            <select
                                                name="select"
                                                className="form-control"
                                                value={ReportsModel.Sucursal}
                                                onChange={event => ChangeSucursal(event)}
                                                style={{ color: "#000", borderRadius: 4, backgroundColor: "transparent", height: 40 }}
                                            >
                                                <option value="---">Selecciona</option>
                                                {!!sucursales && sucursales.map(sucursal => {
                                                    return (
                                                        <option value={sucursal.code}>{`${sucursal.nombre}`}</option>
                                                    )
                                                })}
                                                {/* <option value={'ALL'}>TODAS LAS SUCURSALES</option> */}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                </div>
                                <div className='row'>
                                </div>
                                <div className='row'>
                                    <div className='col-12 col-md-10 mt-3'>
                                        <span><strong>Tipos de operacion:</strong></span>
                                        <div className="form-check mt-3 ml-5">
                                            <input className="form-check-input" type="checkbox" checked={ReportsModel.checkReturn} id="checkReturn" onClick={(event) => ChangeReturn()} />
                                            <label className="form-check-label ml-4" for="checkReturn">
                                                Devoluciones
                                            </label>
                                        </div>
                                        <div className="form-check mt-3 ml-5">
                                            <input className="form-check-input" type="checkbox" checked={ReportsModel.checkCreditNote} id="checkCreditNote" onClick={(event) => ChangeCNote()} />
                                            <label className="form-check-label ml-4" for="checkCreditNote">
                                                Notas de Crédito
                                            </label>
                                        </div>
                                    </div>
                                    <div className='col-12 col-md-2'>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal" >Cancelar</button>
                            <button type="button" className="btn btn-primary" onClick={() => GenerateReport()}>Generar</button>
                        </div>
                    </div>
                </div>

                {ShowPDFViewerModal &&
                    <PdfViewer
                        DocsToPrint={ListReports}
                        TypeDoc={'Report_ReturnCNote'}
                        EnableEditButton={false}
                        Editable={false}
                        ChangeEditableMode={false}
                        EditableDocModel={'SalesTools.EditableDocModel'}
                        RefreshDocModel={'SalesTools.RefreshDocModel'}
                        SaveChanges={'SalesTools.SaveChangesOrderInvoice'}
                        UploadDoc={'SalesTools.UploadInvoice'}
                        EditParam1={false}
                        ShowPDFViewer={ShowPDFViewer}
                        user={'user'}
                        Counter={true}
                        MailTools={MailTools}
                        ReportsModel={ReportsModel}
                        printhide={printhide}
                        ShowFormatToPrint={ShowFormatToPrint}
                        reprint={false}
                    />
                }

                {partners.length > 0 &&
                    <PartnerCreateModal
                        data={partners}
                        type={'C'}
                        totalPage={pageTotal}
                        selectPartner={SelectPartner}
                        cleanData={cleanDataPartners}
                        refreshPartner={RefreshPartner}
                    />
                }
            </div>
        );
    }
}

export default ReportReturnCNoteModal;